import type {ReactAction} from '@netx/core/bootstrap';
import {faArrowCircleDown} from '@fortawesome/pro-solid-svg-icons';
import {canDownloadCurrentCart} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Download cart assets
 * @param params
 * @returns Action
 */
export const cartActionDownload = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-download',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.DOWNLOAD),
	enableTest: canDownloadCurrentCart,
	icon: faArrowCircleDown,
	get label() {
		return CART_CURRENT_ACTION_LABELS.DOWNLOAD;
	},
	...params,
});

export default cartActionDownload;
